var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":_vm.title,"space":"6"}},[_vm._v(_vm._s(_vm.content))]),_c('base-business-contact',{attrs:{"dense":"","business":_vm.business}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }